import { LtiActions, LtiActionsUnion } from '../actions/ltiparams.action';
import {
  LtiParamsState,
  initialLtiParamsState,
} from '../state/ltiparams.state';

export const ltiReducer = (
  state = initialLtiParamsState,
  action: LtiActionsUnion,
): LtiParamsState => {
  switch (action.type) {
    case LtiActions.SetLtiParams: {
      return {
        ...state,
        ltiParams: action.payload.ltiParams,
      };
    }
    case LtiActions.AddModuleTitle: {
      let updatedLtiParams = { ...state.ltiParams };
      updatedLtiParams['moduleTitle'] = action.payload;

      return {
        ...state,
        ltiParams: updatedLtiParams,
      };
    }
    default:
      return state;
  }
};
